export const visitorBookingContextTypes = {
  RESET_VISITORBOOKING_CONTEXT: "context/RESET_VISITORBOOKING_CONTEXT",
  SET_SORTING: "context/SET_SORTING",
  TOGGLE_SHOW_CANCEL_VISITORBOOKING:
    "context/TOGGLE_SHOW_CANCEL_VISITORBOOKING",
  SET_SELECTED_ROW_VALUES: "context/SET_SELECTED_ROW_VALUES",
};
